<template>
    <div class="flex w-full items-center mt-4 bg-gray-100 rounded">
        <div class="flex flex-1 justify-stars">
            <router-link 
                :to="locationRoute(first)" 
                @click="() => page = first"
                title="Primeira página"
                class="hidden sm:inline py-1 px-3 rounded mr-2 bg-brand text-white hover:bg-opacity-90 hover:font-medium"
            >
                <i class="fas fa-chevron-circle-left"></i>
                <i class="fas fa-chevron-circle-left"></i>
                Primeira
            </router-link>
            <router-link 
                :to="locationRoute(prev)" 
                @click="() => page = prev"
                title="Página anterior"
                class="py-1 px-3 rounded mr-2 bg-brand text-white hover:bg-opacity-90 hover:font-medium"
            >
                <i class="fas fa-chevron-circle-left"></i>
                Anterior
            </router-link>
        </div>        
        <ul class="hidden md:flex flex-1 justify-center">
            <li
                v-for="item in range"
                :key="`paging-range-item-${item}`"
            >
                <router-link 
                    :to="locationRoute(item)" 
                    @click="() => page = item"
                    :title="`Página ${item}`"
                    class="py-1 px-3 rounded mx-1 bg-brand text-white hover:bg-opacity-90 hover:font-medium"
                >
                    {{item}}
                </router-link>
            </li>
        </ul> 
        <div class="flex flex-1 justify-end">
            <router-link 
                :to="locationRoute(next)"
                @click="() => page = next"
                title="Próxima página"
                class="py-1 px-3 rounded ml-2 bg-brand text-white hover:bg-opacity-90 hover:font-medium"
            >
                Próxima
                <i class="fas fa-chevron-circle-right"></i>
            </router-link>
            <router-link 
                :to="locationRoute(last)" 
                @click="() => page = last"
                title="Última página"
                class="hidden sm:inline py-1 px-3 rounded ml-2 bg-brand text-white hover:bg-opacity-90 hover:font-medium"
            >
                Última
                <i class="fas fa-chevron-circle-right"></i>
                <i class="fas fa-chevron-circle-right"></i>
            </router-link>
        </div>
    </div>
</template>

<script>
import {reactive, watch, onMounted} from 'vue'
import eventBus from '@/event-hub'

export default {
  
    props: {
        totalItems: { type: Number, required: true },
        pageLimit: { type: Number, required: true },
    },    

    setup (props) {        

        const locationRoute = (page) => {
            const queryString = new URLSearchParams(location.search)

            queryString.set('page', page)

            let query = {}
            for (const [key, val] of queryString.entries())
                query[key] = val

            return { path: location.pathname, query }             
        }  

        const state = reactive({
            page: 1,
            first: 1,
            prev: 1,
            range: null,
            next: 1,
            last: 1,
            locationRoute
        })

        const getRangeLimit = (page, range, totalPages) => {            
            const totalRange = page + range            
            return (totalRange > totalPages) ? range - (totalRange - totalPages) : range;
        }

        const getRange = (page, totalPages, limit=5) => { 
            const length = getRangeLimit(page, limit, totalPages)
            return Array.from({length}, (k, v) => v + page + 1) 
        }

        const getNext = (page, totalPages) => { 
            return (page < totalPages) ? page + 1 : totalPages 
        }

        const getPrevious = (page) => { 
            return (page > 1) ? page - 1 : 1 
        }

        const getTotalPages = (pageLimit, totalItems) => { 
            return Math.ceil(totalItems / pageLimit) 
        }              

        const update = () =>
        {
            const totalPages = getTotalPages(props.pageLimit, props.totalItems)            
            
            let page = parseInt(state.page)
            if( isNaN(page) || page < 0)
                page = 1
            if( page > totalPages )
                page = totalPages
            
            state.prev = getPrevious(page)
            state.next = getNext(page, totalPages)
            state.last = totalPages
            state.range = getRange(page, totalPages, 5)
        }

        watch( 
            () => state.page,
            () => {                
                eventBus.emit('update:resultList', state.page)
                update()
            }            
        )

        onMounted( () => {            
            const queryString = new URLSearchParams(location.search)
            const page = parseInt(queryString.get('page'))
            
            if (! isNaN(page) )                
            { state.page = page }
            update()
        })

        return state
    }
}
</script>

<style lang="css" scoped>
</style>